import Vue from 'vue'
import Vuex from 'vuex'
import Vapi from 'vuex-rest-api'

Vue.use(Vuex)

const errorMessage = (error) => {
  if (error.response && error.response.status === 401) {
    return { ...error, toString: () => '授权已过期，正在自动重新授权' }
  }
  return error
}

// vuex-rest-api only generate vuex on REST api
// it is only helper
const apiStore = new Vapi({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // define custom state here, or they will be non-reactive
  state: {
    config: {
      bAuthRemember: false
    },
    auth: {
      token: localStorage.getItem('token')
    },
    task: {
      cardList: []
    },
    throwState: {
      isThrowing: false,
      cardId: '',
      direction: '',
      indicator: false
    },
    isResetingCard: false
  }
})
  .post({
    action: 'authenticate',
    property: 'auth',
    path: '/authenticate',
    onSuccess: (state, payload, axios, { params, data }) => {
      // TODO move api code back to http
      if (payload.data.code) {
        state.error.auth = payload.data
      } else {
        if (state.config.bAuthRemember && payload.data.token && payload.data.token.length > 0) {
          localStorage.setItem('token', payload.data.token)
          state.auth = { token: localStorage.getItem('token') }
        }
        state.auth = payload.data
      }
    },
    onError: (state, error, axios, { params, data }) => {
      state.error.auth = errorMessage(error)
    }
  })
  .post({
    action: 'fetch5cardsRaw',
    property: 'task',
    path: ({ id }) => `/tasks/${id}/give-me-five`,
    headers: ({ token }) => ({
      'Authentication-Token': token
    }),
    onSuccess: (state, payload, axios, { params, data }) => {
      state.task = Object.assign(state.task, payload.data.task)
      state.task.cardList.push(...payload.data.feeds)
      // console.log(state.task)
    },
    onError: (state, error, axios, { params, data }) => {
      state.error.task = errorMessage(error)
    }
  })
  .patch({
    action: 'updateCardRaw',
    property: 'task',
    path: ({ id }) => `/feeds/${id}`,
    headers: ({ token }) => ({
      'Authentication-Token': token
    }),
    onSuccess: (state, payload, axios, { params, data }) => {
      state.task.finished++
      // state.task.cardList.filter(card => card.id !== payload.data.feed)
    },
    onError: (state, error, axios, { params, data }) => {
      state.error.task = errorMessage(error)
    }
  })
  .get({
    action: 'fetchTaskListRaw',
    property: 'taskList',
    path: '/tasks',
    headers: ({ token }) => ({
      'Authentication-Token': token
    }),
    onError: (state, error, axios, { params, data }) => {
      state.error.taskList = errorMessage(error)
    }
  })
  .getStore()

apiStore.strict = process.env.NODE_ENV !== 'production'
apiStore.getters = {}
const { getters, mutations, actions } = apiStore
getters.isAuthenticated = state => {
  return Number(state.auth && state.auth.token && state.auth.token.length > 0)
}
getters.allTasks = state => {
  if (state.taskList && state.taskList.current && state.taskList.daily) {
    return [...state.taskList.daily, ...state.taskList.current]
  }
}
getters.allCard = state => {
  return state.task.cardList ? state.task.cardList : []
}
mutations.toggleAuthRemember = state => {
  state.config.bAuthRemember = !state.config.bAuthRemember
}
mutations.updateAuthToken = (state, payload) => {
  localStorage.setItem('token', payload)
  // read once to keep data persistent
  state.auth = { token: localStorage.getItem('token') }
}
mutations.clearAuth = state => {
  state.auth = {}
  localStorage.removeItem('token')
}
mutations.clearTask = state => {
  state.task = { cardList: [] }
}
mutations.removeTopCard = state => {
  state.task.cardList.shift()
}
mutations.throwCard = (state, payload) => {
  state.throwState = {
    indicator: true,
    isThrowing: true,
    cardId: payload.id,
    direction: payload.direction
  }
}
mutations.resetCard = state => {
  state.isResetingCard = true
}
mutations.doneResetCard = state => {
  state.isResetingCard = false
}
mutations.hasThrownCard = state => {
  state.throwState.indicator = false
  state.throwState.isThrowing = false
  state.throwState.cardId = ''
}
mutations.changeThrowState = (state, payload) => {
  state.throwState = { ...state.throwState, ...payload }
}
mutations.setTaskError = (state, payload) => {
  state.error.task = payload
}
actions.triggerIndicator = context => {
  context.commit('changeThrowState', { indicator: true })
  setTimeout(() => {
    context.commit('changeThrowState', { indicator: false })
  }, 0)
}
actions.logout = context => {
  context.commit('clearAuth')
}
actions.fetchTaskList = (context, data) => {
  if (!data) data = { params: {} }
  if (!data.params) data.params = {}
  if (context.getters.isAuthenticated) {
    data.params.token = context.state.auth.token
    context.dispatch('fetchTaskListRaw', data)
  }
}
actions.fetch5cards = (context, data) => {
  if (!data || !data.params.id) return
  if (context.getters.isAuthenticated) {
    data.params.token = context.state.auth.token
    context.dispatch('fetch5cardsRaw', data)
  }
}
actions.updateCard = (context, data) => {
  if (!data || !data.params.id || !data.data) return
  if (context.getters.isAuthenticated) {
    data.params.token = context.state.auth.token
    context.dispatch('updateCardRaw', data)
    context.commit('removeTopCard')
  }
}
actions.cardIsGood = (context, data) => {
  data = {
    params: { id: data },
    data: { status: 'GOOD' }
  }
  context.dispatch('updateCard', data)
}
actions.cardIsBad = (context, data) => {
  data = {
    params: { id: data },
    data: { status: 'BAD' }
  }
  context.dispatch('updateCard', data)
}
actions.cardIsConfused = (context, data) => {
  data = {
    params: { id: data },
    data: { status: 'CONFUSED' }
  }
  context.dispatch('updateCard', data)
}
actions.cardIsScored = (context, data) => {
  data = {
    params: { id: data.id },
    data: { status: 'GOOD', score: data.score }
  }
  context.dispatch('updateCard', data)
}
actions.commentCard = (context, data) => {
  data = {
    params: { id: data.id },
    data: { comment: data.comment }
  }
  context.dispatch('updateCard', data)
}

const store = new Vuex.Store(apiStore)

export default store
